// removed by extract-text-webpack-plugin
module.exports = {"photographer":"Nrd0PDrgV5BaJ_H-Bvh4I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PhotoCredit/PhotoCredit.module.scss
// module id = 794
// module chunks = 0